<template>
  <div class="products">
    <div class="header">
      <img src="../../assets/news_banner.png" alt="banner" class="banner" />
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo" />
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back" />
        </router-link>
      </div>
      <div class="swiperBox">
        <div id="swiper">
          <div class="imgBox">
            <div class="imgDiv" v-for="(item, index) of imgList" :key="index">
              <img :src="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <ul>
          <li
            v-for="(item, index) in productsTypeList"
            :key="index"
            :class="{ active: curTabGuid == item.id }"
            @click="checkProductsName(item)"
          >
            <img
              :src="item.product_type_image_address"
              alt="img"
              class="li_img"
            />
            <div class="li_name">
              <span>{{ item.product_type_name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="mid">
        <div class="post-area">
          <div class="post-top">
            <div class="title">齿轮知识 Gear Knowledge</div>
            <div class="pagination">
              <div v-if="nextId == 0" tag="div" class="dis">上一条</div>
              <a v-if="nextId !== 0" :href="'/post/news/' + nextId">上一条</a>

              <div v-if="prevId == 0" tag="div" class="dis">下一条</div>
              <a v-if="prevId !== 0" :href="'/post/news/' + prevId">下一条</a>

              <router-link to="/post/list" tag="div">
                <span> | 返回列表 </span>
                <img
                  src="../../assets/arrow-right-bold-circle.png"
                  alt="箭头"
                />
              </router-link>
            </div>
          </div>
          <div class="post-content" v-if="!!PostData.post_title">
            <div class="post-title">
              {{ PostData.post_title }}
            </div>
            <div class="post-date">{{ PostData.post_date }}</div>
            <div class="post-main">
              <div class="post-imgs">
                <div class="post-img1">
                  <img :src="PostData.post_img1" alt="post_img1" />
                </div>
                <div class="post-img2">
                  <img :src="PostData.post_img2" alt="post_img1" />
                </div>
              </div>
              <div class="post-voice">
                <audio loop controls>
                  <source
                    :src="
                      'http://tsn.baidu.com/text2audio?lan=zh&ctp=1&cuid=abcdxxx&tok=24.0c77f9401f72451370b80f6307fa75e0.2592000.1661904760.282335-9475327&tex=' +
                      PostData.post_content.slice(0, 60) +
                      '&vol=9&per=0&spd=5&pit=5&aue=3'
                    "
                  />
                </audio>
              </div>
              <div class="post-text">
                <div v-html="PostData.post_rtf"></div>
              </div>
            </div>
          </div>
          <div class="post-bottom">
            <a v-if="nextId !== 0" :href="'/post/news/' + nextId"
              >上一篇:{{ nextTitle }}</a
            >
            <a v-if="prevId !== 0" :href="'/post/news/' + prevId"
              >下一篇:{{ prevTitle }}</a
            >
          </div>
        </div>
      </div>
      <div class="right">
        <div class="tips-area">
          <div class="tips-title">标准齿轮小贴士 Tips</div>
          <div class="tips-items">
            <router-link
              tag="div"
              class="tips-item"
              v-for="(item, index) of TipsData"
              :key="index"
              :to="'/post/tips/' + item.id"
              >{{ item.post_title }}</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div class="modal-bg" v-show="showImgDetailModal" @click="closeImgDetai">
      <div class="content" :class="{ active: showImgDetailModal }"></div>
    </div>
    <mb-fotter></mb-fotter>
    <div class="banner_img">
      <img src="../../assets/blo6.png" alt />
    </div>
    <div class="banner_img_1">
      <img src="../../assets/blo7.png" alt />
    </div>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import request from "../../server/request.js";

export default {
  name: "products",
  data() {
    return {
      curTabGuid: this.$route.params.id,
      id: this.$route.params.id,
      prevId: 0,
      prevTitle: "",
      nextTitle: "",
      nextId: 0,
      PostData: {
        // post_content: "123",
        post_rft: "",
      },
      TipsData: [],
      //   couponSelected1: "",
      //   couponSelected2: "",
      //   couponSelected3: "",
      searchValue: "",
      //   selectValue: "",
      showMoalType: 1,
      modalType: 1,
      imgList: [
        require("../../assets/products/1.png"),
        require("../../assets/products/2.png"),
        require("../../assets/products/3.png"),
        require("../../assets/products/4.png"),
        require("../../assets/products/5.png"),
        require("../../assets/products/6.png"),
        require("../../assets/products/7.png"),
        require("../../assets/products/8.png"),
        require("../../assets/products/9.png"),
        require("../../assets/products/10.png"),
        require("../../assets/products/11.png"),
        require("../../assets/products/12.png"),
        require("../../assets/products/13.png"),
        require("../../assets/products/14.png"),
        require("../../assets/products/15.png"),
        require("../../assets/products/16.png"),
        require("../../assets/products/17.png"),
        require("../../assets/products/18.png"),
        require("../../assets/products/19.png"),
        require("../../assets/products/20.png"),
        require("../../assets/products/21.png"),
        require("../../assets/products/22.png"),
        require("../../assets/products/23.png"),
        require("../../assets/products/24.png"),
        require("../../assets/products/25.png"),
      ],
      timer: null,
      productsTypeList: [],
      productsList: [],
      productsListAll: [],
      productsInfo: {
        copy_writing_title: "",
        copy_writing_content: "",
      },
      fileInfo: {},
      fileList: [],
      showCancle: false,
      showModal: false,
      showImgDetailModal: false,
      // showModal1: false,
      titleText: "样册索取",
      PreviewPath: "",
      newLabelPagePath: "",
      // showNewLabel: false
    };
  },

  created() {
    this.loadData();
  },

  mounted() {
    this.move();
  },

  components: {
    mbFotter,
  },

  methods: {
    toDetail(e) {
      console.log(this.$route);
      const query = e.guid;
      console.log(query);
      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     guid: query,
      //   },
      // });
      // console.log(e);
    },
    showImgDetail(e) {
      console.log(e);
      this.showImgDetailModal = true;
    },

    closeImgDetai() {
      this.showImgDetailModal = false;
    },
    loadData() {
      request.getProductsById(this.curTabGuid, (res) => {
        if (res && res.errcode === 0) {
          console.log(res.data, "res.data");
          this.productsList = res.data;
        }
      });
      request.getProductsType((res) => {
        if (res && res.errcode === 0) {
          this.productsTypeList = res.data;
          // this.imgList = res.data.map(item => item.product_type_image_address)
        }
      });
      request.getProductsCenterInfo((res) => {
        if (res && res.errcode === 0) {
          if (res.data.length === 0) {
            this.productsInfo = {
              copy_writing_content: "",
              copy_writing_title: "",
            };
          } else {
            this.productsInfo = res.data.filter(
              (item) =>
                item.product_type_id == this.curTabGuid &&
                item.copy_writing_location === "Produces"
            )[0];
          }
        }
      });

      request.getFileDown((res) => {
        if (res && res.errcode === 0) {
          this.fileList = res.data;
          this.fileInfo = res.data.filter(
            (item) => item.file_location === "/khk004b"
          )[0];
        }
      });

      request.getPostInfoById(this.id, (res) => {
        if (res && res.length > 0) {
          const _Data = res;
          this.PostData = _Data[0];
          console.log("this.PostData");
          console.log(this.PostData);
          document.title = _Data[0].post_tags;
        }
      });

      request.getTipsList((res) => {
        if (res && res.length > 0) {
          const _Data = res;
          this.TipsData = _Data.slice(0, 10);
        }
      });
      request.getNewsList((res) => {
        if (res && res.length > 0) {
          const _Data = res;
          if (this.id) {
            const currentIndex = _Data.findIndex((item) => item.id == this.id);
            console.log("currentIndex", currentIndex);
            if (currentIndex >= 1) {
              this.nextId = _Data[currentIndex - 1].id;
              this.nextTitle = _Data[currentIndex - 1].post_title;
            } else {
              this.nextId = 0;
            }

            if (currentIndex < _Data.length) {
              this.prevId = _Data[currentIndex + 1].id;
              this.prevTitle = _Data[currentIndex + 1].post_title;
            } else {
              this.prevId = 0;
            }
          }
        }
      });
    },
    // Preview(item) {
    //   this.showModal = true;
    //   this.showNewLabel = true;
    //   this.PreviewPath = item.product_big_image_address;
    //   const mainContent = document.getElementById("mainContent");
    //   mainContent.src = item.product_big_image_address;
    //   this.titleText = "尺寸表";
    //   this.newLabelPagePath = item.product_big_image_address;
    // },
    // zoutFFWk(type) {
    //   this.showModal = true;
    //   this.titleText = type;
    //   this.showNewLabel = true;
    //   const mainContent = document.getElementById("mainContent");
    //   switch (type) {
    //     case "2D 图纸下载":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     case "3D 图纸下载":
    //       mainContent.src =
    //         "https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=" +
    //         this.searchValue;
    //       break;
    //     case "强度计算":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     case "追加工制图":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     default:
    //       break;
    //   }
    // },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
          this.showMoalType = 1;
          this.modalType = 1;
          this.newLabelPagePath = "";
          // this.showNewLabel = false;
        }
      }
    },
    // closeImgDetai

    download_pdf() {
      this.showModal = true;
      this.showMoalType = 3;
      this.titleText = "各国材料及精度等级对照表查阅";
      this.modalType = 2;
      this.PreviewPath = require("../../assets/new.jpg");
    },
    move() {
      let imgBox = document.getElementsByClassName("imgBox")[0];
      imgBox.innerHTML += imgBox.innerHTML;
      let imgDiv = document.getElementsByClassName("imgDiv");
      imgBox.style.width = imgDiv.length * this.imgWidth + "px";
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (imgBox.offsetLeft < -(imgBox.offsetWidth / 2 - 364)) {
          //向左滚动
          imgBox.style.left = 0;
        }
        imgBox.style.left = imgBox.offsetLeft + -Math.abs(1) + "px";
      }, 30);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },

    closeModalCuspor() {
      this.showModal = false;
      // this.showNewLabel = false;
    },
    checkProductsName(item) {
      this.curTabGuid = item.id;
      this.$router.push("/products/" + item.id);
    },
  },
};
</script>

<style lang="less" scoped>
.products {
  position: relative;
  // margin: o auto;
  .banner_img {
    position: absolute;
    right: 0;
    bottom: 140px;
    z-index: 1;
  }
  .banner_img_1 {
    position: absolute;
    left: 0;
    bottom: 140px;
    z-index: 1;
  }
  .header {
    position: relative;
    .banner {
      width: 100%;
      background-size: 100% 100%;
      vertical-align: top;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0.3rem 1rem;
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }

    .swiperBox {
      height: 120px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      #swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .imgBox {
          position: absolute;
          left: 0;
          top: 0;
          overflow: hidden;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          .imgDiv {
            width: 120px;
            // height: 100%;
            background-size: 100% 100%;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              opacity: 0.7;
            }
          }
        }
      }
    }
  }
  .body {
    background: #fff;
    display: flex;
    padding: 0.9rem 4.8rem 0 4.8rem;
    .left {
      margin-left: 3%;
      width: 20%;
      border-right: 1px solid #0583c9;
      position: relative;
      z-index: 10;
      ul {
        display: flex;
        flex-direction: column;
        width: 100%;
        li {
          width: 90%;
          height: 1.68rem;
          border: 2px solid#0583C9;
          display: flex;
          align-items: center;
          border-radius: 5px;
          margin-bottom: 0.3rem;
          position: relative;
          background: #fff;
          cursor: pointer;
          &.active {
            border-right: 10px solid #0583c9;
          }
          &.active::before {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: -18px;
            top: 0.6rem;
            border-top: solid 10px transparent;
            border-left: solid 10px #0583c9;
            border-bottom: solid 10px transparent;
          }
          .li_img {
            height: 80px;
          }
          .li_name {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-weight: 600;
              font-size: 0.34rem;
              color: #0583c9;
            }
          }
        }
      }
    }
    .mid {
      width: 55%;
      border-right: 1px solid #0583c9;
      z-index: 999;
      .mask {
        padding: 0 0.6rem;
        color: #0583c9;
        border-bottom: 1px solid #0583c9;
        h3 {
          margin: 0.2rem 0;
          font-size: 0.48rem;
          font-weight: 700;
        }
      }
      .list_img {
        width: 100%;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;

        ul {
          padding-top: 0.48rem;
          display: flex;
          flex-wrap: wrap;
          width: 620px;
          li {
            width: 180px;
            margin-right: 40px;
            height: 198px;
            margin-bottom: 0.61rem;
            border-radius: 10px;
            &:nth-child(3n) {
              margin-right: 0;
            }
            a {
              display: block;
              position: relative;
              width: 100%;
              height: 178px;
              cursor: pointer;
              // background: #0583c9;
              .list_li_img {
                width: 100%;
                height: 100%;
              }
              .sub-mask {
                // display: visibility: hidden;;
                visibility: hidden;
              }
              &:hover .sub-mask {
                visibility: visible;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.45);
                .content {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  // margin: auto;
                  transform: translate(-50%, -50%);
                  font-weight: 500;
                  color: #fff;
                  font-size: 14px;
                  text-align: center;
                  .name {
                    margin-bottom: 30px;
                  }
                  .link {
                    width: 80px;
                    height: 30px;
                    background: #0583c9;
                    line-height: 30px;
                    border-radius: 5px;
                    color: #fff;
                    a {
                      color: #fff;
                    }
                  }
                }
              }
            }

            .btn {
              text-align: center;
              cursor: pointer;
              // color: #0583C9;
              width: 1.2rem;
              height: 0.44rem;
              border-radius: 3px;
              line-height: 0.44rem;
              margin-left: 35%;
              color: #0583c9;
              margin-top: 5px;
              border: 1px solid #0583c9;
              &:hover {
                color: #fff;
                background: #0583c9;
              }
            }
          }
        }
      }
    }
    .right {
      width: 30%;
      position: relative;
      z-index: 10;
      .download,
      .fast_seearch {
        display: flex;
        flex-direction: column;
        padding: 0 10%;
        .download_btn {
          display: flex;
          align-items: center;
          border: 1px solid #0583c9;
          background: #fff;
          justify-content: center;
          width: 100%;
          height: 1.68rem;
          border-radius: 5px;
          padding: 0.1rem 0;
          margin-bottom: 0.5rem;
          color: #0583c9;
          font-size: 0.28rem;
          font-weight: 500;
          line-height: 1.5;
          cursor: pointer;
          &.btn {
            height: auto;
            padding: 0.1rem 0;
            a {
              color: #0583c9;
              span {
                width: 100%;
                text-align: center;
                color: #0583c9;
                letter-spacing: 1px;
              }
              a {
                color: #0583c9;
              }
            }
          }
          .download_pdf {
            // width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0583c9;
            span {
              width: 40%;
              display: inline-block;
              color: #0583c9;
              margin-right: 10px;
            }
            a {
              color: #0583c9;
            }
          }
        }
        .fast_seearch_h3 {
          color: #0583c9;
        }
        .fast_seearch_input {
          width: 100%;
          padding: 0.1rem 0;
          margin-bottom: 0.5rem;
          border-radius: 5px;
          border: 1px solid #ccc;
          text-align: center;
          height: auto;
          height: 0.78rem;
          color: #333;
        }
        .downlo_2d {
          width: 100%;
          .fast_seearch_select {
            width: 100%;
            background: #fff;
            margin-bottom: 0.2rem;
            height: 0.68rem;
            color: #ccc;
            text-align: center;
            option {
              text-align: center;
            }
          }
        }
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 15px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      width: 1200px;
      background: #fff;
      position: relative;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      max-height: 710px;
      overflow: scroll;
      &.active {
        width: 500px;
      }
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-label {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        padding: 0;
        padding-left: 10px;
        line-height: 48px;
        color: #0583c9;
        text-decoration: none;
        font-size: 12px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: center;
        padding: 0.3rem 0 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        #mainContent {
          border: none;
          min-height: 800px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  // .modal-bg {
  //   background: rgba(0, 0, 0, 0.6);
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 20;

  //   .content {
  //     width: 300px;
  //     height: 300px;
  //     position: absolute;
  //     top: 300px;
  //     left: 0;
  //     right: 0;
  //     margin: 0 auto;
  //     background: #8fcff1;
  //     transition: all 3s ease;
  //     z-index: 30;

  //   }

  // }
}

.post-area {
  .post-top {
    height: 42px;
    font-size: 23px;
    font-weight: 500;
    color: #0583c9;
    line-height: 42px;
    padding: 0 24px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #0583c9;
    align-items: flex-end;
    .title {
    }
    .pagination {
      font-size: 15px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      font-weight: 400;
      cursor: pointer;
      > div {
        padding-right: 6px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
      }
      > a {
        padding-right: 6px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        color: #0583c9;
        &:hover {
          color: #0583c9;
        }
      }
      .dis {
        color: #808080;
      }
      img {
        width: 20px;
        margin-left: 12px;
      }
    }
  }
  .post-content {
    text-align: center;
    padding: 24px 0;
    .post-title {
      font-size: 19px;
      font-weight: 500;
      color: #0583c9;
      line-height: 42px;
      text-align: center;
    }
    .post-date {
      font-size: 15px;
      font-weight: 500;
      color: #333;
    }
    .post-main {
      width: 584px;
      border-top: 1px solid #0583c9;
      margin: 0 auto;
      margin-top: 12px;
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      .post-imgs {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin: 16px;
        height: 190px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .post-img1 {
          width: 190px;
          margin-right: 24px;
        }
        .post-img2 {
          width: 361px;
        }
      }
      .post-voice {
        width: 100%;
        > audio {
          width: 100%;
        }
      }
      .post-text {
        padding: 12px 0;
        width: 100%;
        display: block;
        text-align: left;
        // font-size: 15px;
        font-weight: 400;
        color: #333333;
        white-space: pre-wrap;

        // line-height: 24px;
        // white-space: pre
        p {
          min-height: 16px;
        }
      }
    }
  }
  .post-bottom {
    border-top: 1px solid #0583c9;
    padding: 12px 0;
    margin: 0 12px;
    font-size: 19px;
    font-weight: 500;
    color: #0583c9;
    line-height: 36px;
    display: flex;
    flex-flow: column;

    a {
      // display: inline-block;
      width: 590px;
      margin: 0 auto;
      cursor: pointer;
      z-index: 9999;
      color: #0583c9;
    }
    a:hover {
      color: #0583c9;
    }
  }
}
.tips-area {
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  .tips-title {
    width: 297px;
    height: 48px;
    background: #0583c9;
    border-radius: 6px;
    color: #fff;
    text-align: center;
    line-height: 48px;
    margin: 12px 0 36px 0;
  }
  .tips-items {
    .tips-item {
      width: 297px;
      height: 42px;
      background-color: rgba(5, 131, 201, 0.1);
      color: #0583c9;
      border-radius: 6px;
      line-height: 42px;
      text-align: left;
      margin: 11px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      box-sizing: border-box;
      padding-left: 32px;
      &:hover {
        cursor: pointer;
        color: #fff;
        background-color: #0583c9;
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .products {
    .body {
      padding: 0.9rem 0 0 0;
    }
  }
}
</style>
